// Phase 84.M.86 — Provider điều phối Modal + Sticky banner + Inline warnings
// cho in-app browser detection.
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  detectInAppBrowser,
  getBannerDismissed,
  setBannerDismissed,
} from "../lib/inAppBrowser";
import InAppBrowserBanner from "../components/inapp/InAppBrowserBanner";

const InAppBrowserContext = createContext({
  inAppInfo: { isInApp: false, isMobile: false, app: null, appId: null, os: "other" },
});

export function InAppBrowserProvider({ children }) {
  // SSR-safe: chỉ detect khi mount client-side.
  const [info, setInfo] = useState({ isInApp: false, isMobile: false, app: null, appId: null, os: "other" });
  const [bannerOpen, setBannerOpen] = useState(false);

  useEffect(() => {
    const result = detectInAppBrowser();
    setInfo(result);
    // User choice 5a — Chỉ kích hoạt khi mobile + isInApp.
    // Phase 85.A.268 — Bỏ modal popup (gây vướng). CHỈ giữ banner gợi ý đầu trang.
    if (result.isInApp && result.isMobile) {
      if (!getBannerDismissed()) setBannerOpen(true);
    }
  }, []);

  const closeBanner = () => {
    setBannerDismissed();
    setBannerOpen(false);
  };

  const value = useMemo(() => ({ inAppInfo: info }), [info]);

  return (
    <InAppBrowserContext.Provider value={value}>
      {/* Banner sticky top — gợi ý mở Safari/Chrome (không còn modal popup). */}
      {info.isInApp && info.isMobile && bannerOpen && (
        <InAppBrowserBanner info={info} onClose={closeBanner} />
      )}
      {children}
    </InAppBrowserContext.Provider>
  );
}

export function useInAppBrowser() {
  return useContext(InAppBrowserContext);
}
